module.exports = __webpack_public_path__ + "img/0Q3B3199_L_Black_MockedUp.ed6f8589.jpg";